const permissions = JSON.parse(localStorage.getItem("permissions"));

export const checkPermission = (permissionName, navName = "") => {
    if (!permissions) return true;
    return permissions.some(permission =>
        navName === "child"
            ? (permission.key_name === permissionName || permission.name === permissionName)
            : (permission.page === permissionName)
    );
};